import {ViewPersonalConfig} from "../../@type";
import {PersonalViewLocation} from "../@types";
import {ViewType} from "../../../../gd/const/views/view-type";
import MainMenu_MyGoals from "../../../../../layout/menu/sections/custom-view/my-goals";
import {Feature} from "../../../../gd/access-control/feature-access/const";

export const MY_GOALS_CONFIG : ViewPersonalConfig = {
    type                : ViewType.MY_GOALS,
    name                : 'Goals',
    icon                : 'i5-goals',
    iconSvg             : 'isvg-goals',
    url                 : 'goals',
    description         : 'Goals Management and Achievement',
    defaultLocation     : PersonalViewLocation.HOME_MORE,
    mainMenuComponent   : MainMenu_MyGoals,
    feature             : Feature.GOALS
}
